import videojs from 'video.js';

videojs.registerPlugin('spritePlugin', function (spriteArray) {
  const player = this;

  function updateSprite(hoverTime) {
    const timeTooltip = player.el().querySelector('.vjs-time-tooltip');
    if (timeTooltip) {
      // Determine which sprite URL to use based on 100-second intervals
      const spriteIndex = Math.floor(hoverTime / 100);
      const currentSpriteURL = spriteArray[spriteIndex % spriteArray.length];
      timeTooltip.style.backgroundImage = `url(${currentSpriteURL})`;
      
      // Calculate frame within the 100-second interval
      const intervalStartTime = spriteIndex * 100;
      const timeInInterval = hoverTime - intervalStartTime;

      // Determine frame row and column within the sprite image
      const totalFrames = 10 * 10; // 10 columns x 10 rows
      const frameDuration = 100 / totalFrames; // Duration per frame in seconds
      const frameIndex = Math.floor(timeInInterval / frameDuration);
      const row = Math.floor(frameIndex / 10);
      const col = frameIndex % 10;
      // Set background position for the correct frame within the sprite
      timeTooltip.style.backgroundPosition = `-${col * 143}px -${row * 92}px`; // Adjust based on cell size
      timeTooltip.style.backgroundRepeat = 'no-repeat';
      // timeTooltip.style.backgroundSize = '3000% 1000%'; // Adjust for 30x10 grid

      // Tooltip styling
      timeTooltip.style.width = '143px';
      timeTooltip.style.height = '92px';
      timeTooltip.style.top = '-92px';
      timeTooltip.style.color = 'rgb(255, 255, 255)';
      timeTooltip.style.textShadow = '1px 1px rgb(0, 0, 0)';
      timeTooltip.style.margin = '0px 1px';
      timeTooltip.style.right = '-72px';
    }
  }

  // Update sprite position based on hover over the progress bar
  function updateSpriteOnHover(event) {
    const progressBar = player.controlBar.progressControl.seekBar;
    const progressBarRect = progressBar.el().getBoundingClientRect();
    const mouseX = event.clientX - progressBarRect.left;
    const duration = player.duration();
    const hoverTime = (mouseX / progressBarRect.width) * duration;

    updateSprite(hoverTime);
  }

  // Initialize the plugin when player is ready
  player.ready(() => {
    const progressBar = player.controlBar.progressControl.seekBar;
    progressBar.on('mouseenter', updateSpriteOnHover);
    progressBar.on('mousemove', updateSpriteOnHover);
  });
});
